import { Observable } from 'rxjs';

export const asObservable = function <T>(promise: Promise<T>): Observable<T> {
  return new Observable(emitter => {
    promise.then(value => {
      emitter.next(value);
      emitter.complete();
    }).catch(error => emitter.error(error));
  });
}